import { render, staticRenderFns } from "./addBusinessContactDialog.vue?vue&type=template&id=3627c925"
import script from "./addBusinessContactDialog.vue?vue&type=script&lang=js"
export * from "./addBusinessContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports